import teamBanner from '../assets/team-banner.jpg';

const TeamBanner = () => {
  return (
    <section>
      {/* Título arriba, con mismo azul que NoticiasGrid */}
      <div className="bg-[#202C5A] text-white text-2xl md:text-3xl font-bold px-6 py-4 uppercase">
        EL EQUIPO
      </div>

      {/* Imagen sin recorte ni limitación de altura */}
      <div className="w-full bg-black">
        <img
          src={teamBanner}
          alt="El equipo"
          className="w-full h-auto object-contain"
        />
      </div>
    </section>
  );
};

export default TeamBanner;
